<template>
<div>
    <p v-if="!this.registration.registered()">Sie sind nicht für denn Wettbewerb angemeldet</p>

    <p v-else-if="!this.competition.isOnline()">Der Zugangscode ist nur im Zeitraum des Online-Wettbewerbs verfügbar</p>

    <div v-else>
      <token
              v-if="this.competition.isOnline() && this.registration"
              :registrationId="this.registration.id"
              class="mb-2">
      </token>
    </div>

</div>
</template>
<script>
import Token from '@/components/competitions/details/OnlineToken'

export default {
  name: 'CompetitionOnline',
  props: ['competition', 'registration'],
  components: {
    token: Token
  }
}
</script>


// WEBPACK FOOTER //
// src/components/competitions/details/Online.vue